import { createContext } from 'react'

export const MobileViewContext = createContext({
    isMobileView: false,
    updateMobileView: () => { }
});
